// Keeps an embroidery add-on line and the product it was added with together in
// the cart: if either is removed, the whole linked group is removed.
//
// custom-embroidery.js tags both lines with a shared `_embroidery_link` token
// when embroidery is added, and flags the add-on line(s) with `_embroidery_addon`.
// A group is valid only while it has BOTH a parent (main product) line and at
// least one add-on line; once either side is removed the group is "broken" and
// the remaining line(s) are removed too.
(function () {
  const LINK_PROP = '_embroidery_link';
  const ADDON_PROP = '_embroidery_addon';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let reconciling = false;

  function prop(item, key) {
    return item && item.properties && item.properties[key];
  }

  async function getCart() {
    return (await fetch(`${root}cart.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json();
  }

  // Return the line keys of every broken link-group.
  function brokenLineKeys(cart) {
    const groups = {};
    (cart.items || []).forEach(item => {
      const token = prop(item, LINK_PROP);
      if (token) (groups[token] || (groups[token] = [])).push(item);
    });

    const keys = [];
    Object.keys(groups).forEach(token => {
      const lines = groups[token];
      const hasParent = lines.some(l => !prop(l, ADDON_PROP));
      const hasAddon = lines.some(l => prop(l, ADDON_PROP));
      if (!hasParent || !hasAddon) {
        lines.forEach(l => keys.push(l.key));
      }
    });
    return keys;
  }

  async function reconcile(cart) {
    if (reconciling) return;
    cart = cart || (await getCart());
    const keys = brokenLineKeys(cart);
    if (!keys.length) return;

    reconciling = true;
    let ok = true;
    try {
      for (const key of keys) {
        const res = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        if (!res.ok) ok = false;
      }
    } catch (e) {
      ok = false;
      console.error('[embroidery-cart-link] Failed to remove linked line', e);
    }
    reconciling = false;

    // Bail without refreshing if a removal failed, to avoid a reload loop.
    if (!ok) return;

    const onCartPage = window.themeVariables
      && window.themeVariables.settings
      && window.themeVariables.settings.pageType === 'cart';

    if (onCartPage) {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  // Drawer removals dispatch cart:change with the updated cart (any page).
  document.addEventListener('cart:change', event => {
    if (reconciling) return;
    reconcile(event.detail && event.detail.cart);
  });

  // Cart-page removals do a full reload instead of firing cart:change, so
  // reconcile once when the cart page loads.
  const onCartPageLoad = window.themeVariables
    && window.themeVariables.settings
    && window.themeVariables.settings.pageType === 'cart';
  if (onCartPageLoad) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => reconcile());
    } else {
      reconcile();
    }
  }
})();
